module.exports = __webpack_public_path__ + "static/img/hover-iocn82.bc00962.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn82.png
// module id = g7+Y
// module chunks = 3